import { Injectable } from '@angular/core';

import { Observable, Observer, Subscriber } from 'rxjs';

import { LanguageService } from './language-service';
import { Page, Language } from './../data';
import { PageQuery } from './../queries';

@Injectable()
export class PageService {
  private mFind: Observable<Page[]>;
  private mLang: Observable<string>;
  private mCache: Map<string, Observable<Page>>;

  constructor(private languageService: LanguageService) {
    this.mLang = this.languageService.getCurrentLang();
    this.mCache = new Map();
  }

  public find() {
    if (!this.mFind) {
      this.mFind = new PageQuery()
        .include(Page.IMAGE_KEY)
        .rx()
        .find();
    }
    return this.mFind;
  }

  public search() {
    return this.permalink(Page.SEARCH_PERMALINK);
  }

  public home() {
    return this.permalink(Page.HOME_PERMALINK);
  }

  public aboutUs() {
    return this.permalink(Page.ABOUT_US_PERMALINK);
  }

  public career() {
    return this.permalink(Page.CAREER_PERMALINK);
  }

  public locations() {
    return this.permalink(Page.LOCATIONS_PERMALINK);
  }

  public ourExpertise() {
    return this.permalink(Page.OUR_EXPERTISE_PERMALINK);
  }

  public ourStrength() {
    return this.permalink(Page.OUR_STRENGTH_PERMALINK);
  }

  public expertise() {
    return this.permalink(Page.EXPERTISE_PERMALINK);
  }

  public ourNetwork() {
    return this.permalink(Page.OUR_NETWORK_PERMALINK);
  }

  public contactUs() {
    return this.permalink(Page.CONTACT_US_PERMALINK);
  }

  public permalink(permarlink: string) {
    return this.mLang.switchMap(lang => {
      let key = permarlink + '-' + lang;

      if (!this.mCache.get(key)) {
        let page = new PageQuery()
          .includeTranslation(Page.IMAGE_KEY, Language.DEFAULT_LANG)
          .includeTranslation(Page.IMAGE_KEY, lang)
          .equalTo(Page.PERMALINK_KEY, permarlink)
          .rx()
          .first()
          .publishReplay(1)
          .refCount();

        this.mCache.set(key, page);
      }
      return this.mCache.get(key);
    });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/services/page-service.ts